export interface GetReportParagraphsRequest {
    /**
     * 任务 ID
     */
    task_id: string;
}

export interface GetReportParagraphsResponse {
    /**
     * 段落问题列表
     */
    chapters: {
        chapter_type: string;
        paragraphs?: {
            paragraph_number: string;
            paragraph_content: string;
            /**
              * 实施例编号
            */
            embodiment_number?: number;
            /**
              * 实施例类型(embodiment_outline, embodiment_content, embodiment)
              */
            embodiment_type?: string;
            /**
              * 段落分割索引
              */
            split_index: number;
        }[];
        figures?: {
            unique_id: string;
            abstract_figure: boolean;
            image: {
                url: string;
            },
            annotation_image_base64?: string;
        }[]
    }[];
}

export const GetReportParagraphsApi = Symbol.for('GetReportParagraphsApi');

export interface GetReportParagraphsApi {
    /**
     * 获取报告段落问题列表
     * @param data 请求参数
     * @param abortSignal 取消信号
     */
    getReportParagraphs(data: GetReportParagraphsRequest, abortSignal?: AbortSignal): Promise<GetReportParagraphsResponse>;
}
